import {useCallback, useState} from 'react';

export default function useModal(open?: boolean) {
    const [isOpen, setIsOpen] = useState<boolean>(!!open);

    const toogle = useCallback((ss?: any) => {
        setIsOpen(dd => (typeof ss === 'boolean' ? ss : !dd));
    }, []);

    return {isOpen, toogle};
}
